export class POIRoutingConstants {
    static POI_ROUTE = "poi";
}
